import { Service } from '@roc/feature-app-core';

const url = {
  GET_QUOTE_BY_ID: '/platform-api/v1/los-loans/quotes/id/',
  GET_QUOTE_BY_QUOTE_NUMBER: '/platform-api/v1/los-loans/quotes/quote-number',
  DELETE_QUOTE_BY_QUOTE_NUMBER: '/platform-api/v1/los-loans/quotes/quote-number',
  GET_LOAN_BY_NUMBER: '/platform-api/v1/los-loans/loans/loan-number/',
  SAVE_QUOTE: '/platform-api/v1/los-loans/quotes/save',
  STATE_COUNTIES: '/api/v1/pricer/stateCounties',
  SAVE_LOAN: '/platform-api/v1/los-loans/loans/save',
  GET_ALL_BORROWER_ENTITIES: '/api/v1/loan/borrowerEntity/getAllEntities',
  GET_ENTITY_DROPDOWN_DATA_LIST: '/api/v1/loan/oneTool/getEntitiesDropdownData',
  GET_ENTITY_BY_ID: '/api/v1/loan/oneTool/getEntityById',
  GET_BORROWER_BY_ID: '/api/v1/loan/borrower/getBorrowerById',
  FIND_BORROWERS_BY_NAME: '/api/v1/loan/oneTool/findBorrowersByName',
};

export class QuoteService extends Service {
  getQuoteById(quoteId: number) {
    return this.get(`${url.GET_QUOTE_BY_ID}/${quoteId}`, {});
  }

  getQuoteByQuoteNumber(quoteNumber: string) {
    return this.get(`${url.GET_QUOTE_BY_QUOTE_NUMBER}/${quoteNumber}`, {});
  }

  deleteQuoteByQuoteNumber(quoteNumber: string) {
    return this.delete(`${url.DELETE_QUOTE_BY_QUOTE_NUMBER}/${quoteNumber}`, {});
  }

  getLoanByNumber(loanNumber: number) {
    return this.get(`${url.GET_LOAN_BY_NUMBER}/${loanNumber}`, {});
  }

  saveQuote(quoteData: any) {
    return this.post(url.SAVE_QUOTE, quoteData);
  }

  getStateCounties() {
    return this.get(url.STATE_COUNTIES);
  }

  saveLoan(quoteData: any) {
    return this.post(url.SAVE_LOAN, quoteData);
  }

  getAllBorrowerEntities() {
    return this.get(url.GET_ALL_BORROWER_ENTITIES);
  }

  getEntityDropdownData(cancelToken?) {
    return this.get(url.GET_ENTITY_DROPDOWN_DATA_LIST, {}, { cancelToken });
  }

  getEntityById(entityId: number) {
    return this.get(url.GET_ENTITY_BY_ID, { entityId });
  }

  fetchBorrowerData(borrowerId) {
    return this.get(url.GET_BORROWER_BY_ID, { borrowerId });
  }

  findBorrowersByName(name: string, cancelToken?) {
    return this.get(
      url.FIND_BORROWERS_BY_NAME,
      { name },
      { disableGlobalLoading: true, cancelToken }
    );
  }
}
